export const root       = '/';
export const about      = '/אודות';
export const contact    = '/צור_קשר';
export const treatment = '/טיפול'

/* documentation */
export const docs       = '/docs';